import { __extends } from "tslib";
import { DeleteEventStreamRequest, DeleteEventStreamResponse } from "../models/models_0";
import { deserializeAws_restJson1DeleteEventStreamCommand, serializeAws_restJson1DeleteEventStreamCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteEventStreamCommand = /** @class */ (function (_super) {
    __extends(DeleteEventStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteEventStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteEventStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "DeleteEventStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DeleteEventStreamRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteEventStreamResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteEventStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeleteEventStreamCommand(input, context);
    };
    DeleteEventStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeleteEventStreamCommand(output, context);
    };
    return DeleteEventStreamCommand;
}($Command));
export { DeleteEventStreamCommand };
//# sourceMappingURL=DeleteEventStreamCommand.js.map